import React, { useState } from 'react';

type Props = {
    filter: any;
    setFilter: (filter: any) => void;
};

const DispatchProgramFilter = ({ filter, setFilter }: Props) => {
    const [localFilter, setLocalFilter] = useState<any>({ ...filter });

    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setLocalFilter({ ...localFilter, [e.target.name]: e.target.value });
    };

    const search = () => {
        setFilter({ ...localFilter, page: 1 });
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') search();
    };

    return (
        <div className="row">
            <div className="row">
                <div className="col-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="dispatch_program_id">
                            Despacho
                        </label>
                        <input
                            title="Número"
                            type="number"
                            id="dispatch_program_id"
                            name="dispatch_program_id"
                            className="form-control form-control-sm"
                            value={localFilter.dispatch_program_id ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="transportation_order_id">
                            Pedido
                        </label>
                        <input
                            title="Pedido"
                            type="number"
                            id="transportation_order_id"
                            name="transportation_order_id"
                            className="form-control form-control-sm"
                            value={localFilter.transportation_order_id ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="quote_id">
                            Cotización
                        </label>
                        <input
                            title="Cotización"
                            type="number"
                            id="quote_id"
                            name="quote_id"
                            className="form-control form-control-sm"
                            value={localFilter.quote_id ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="client">
                            Cliente
                        </label>
                        <input
                            title="Cliente"
                            type="text"
                            id="client"
                            name="client"
                            className="form-control form-control-sm"
                            value={localFilter.client ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="start_date">
                            Desde
                        </label>
                        <input
                            type="date"
                            id="start_date"
                            name="start_date"
                            className="form-control form-control-sm"
                            value={localFilter.start_date ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="end_date">
                            Hasta
                        </label>
                        <input
                            type="date"
                            id="end_date"
                            name="end_date"
                            className="form-control form-control-sm"
                            value={localFilter.end_date ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="sector">
                            Sector
                        </label>
                        <select
                            id="sector"
                            name="sector"
                            className="form-control form-select-sm"
                            value={localFilter.sector ?? ''}
                            onChange={handlerInputFilter}
                        >
                            <option value="TODOS">TODOS</option>
                            <option value="TRANSPORTE">Transporte</option>
                            <option value="ALMACENAMIENTO">Almacenamiento</option>
                        </select>
                    </div>
                </div>
                <div className="col-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="dispatch_program_status">
                            Estatus
                        </label>
                        <select
                            id="dispatch_program_status"
                            name="dispatch_program_status"
                            className="form-control form-select-sm"
                            value={localFilter.dispatch_program_status ?? ''}
                            onChange={handlerInputFilter}
                        >
                            <option value="TODOS">TODOS</option>
                            <option value="DESPACHO">Despachando</option>
                            <option value="FINALIZADO">Finalizado</option>
                        </select>
                    </div>
                </div>
                <div className="col-auto d-flex align-items-center">
                    <div className="mb-3 mt-3">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={search}
                        >
                            <i className="mdi mdi-magnify me-1" />
                            Buscar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DispatchProgramFilter;
